<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/EmployeeTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)"
		class="custom-dialog __form-password"
		:title="$t(Object.entries(this.data).length === 0 ? 'AddNewEmployee' : 'UpdateEmployee')"
		:visible.sync="isSidebarActiveLocal"
	>
		<PerfectScrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- CODE -->
				<vs-input :label="`${$t('Code')}:`" :placeholder="`${$t('Actions.Input')} ${$t('Code')}`" v-model="dataCode" class="mb-5 w-full" name="code" />

				<!-- NAME -->
				<label for class="vs-input--label">
					{{ $t("FullName") }}
					<span class="text-danger">*</span>:
				</label>
				<vs-input :data-vv-as="$t('FullName')" :placeholder="`${$t('Actions.Input')} ${$t('FullName')}`" v-model="dataName" class="w-full" name="name" v-validate="'required'" />
				<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>

				<!-- DOB -->
				<div class="birthDate my-5">
					<label for class="vs-input--label">{{ $t("DOB") }}:</label>
					<vx-input-group>
						<template slot="append">
							<div class="append-text text-black">
								<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker"></i>
							</div>
						</template>

						<cbs-date-picker
							clearable
							class="w-full"
							prefix-icon="''"
							ref="dateTimePickerRef"
							:format="userDateFormat"
							value-format="yyyy-MM-dd"
							:placeholder="`${$t('Actions.Choose')} ${$t('DOB').toLowerCase()}`"
							v-model="birthDate"
						/>
					</vx-input-group>
				</div>

				<!-- EMAIL -->
				<div class="my-5">
					<label for class="vs-input--label">
						{{ $t("Email") }}:
						<!-- <span class="text-danger">*</span>: -->
					</label>
					<vs-input
						v-model="dataEmail"
						type="email"
						class="w-full"
						name="email"
						:data-vv-as="$t('Email')"
						:placeholder="`${$t('Actions.Input')} ${$t('Email')}`"
						v-validate="{ email: true }"
					/>
					<span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
				</div>

				<!-- PHONE -->
				<label for class="vs-input--label block">
					{{ $t("Phone") }}
					<span class="text-danger">*</span>:
				</label>
				<vs-input
					:data-vv-as="$t('Phone')"
					:placeholder="`${$t('Actions.Input')} ${$t('Phone')}`"
					v-model="dataPhone"
					class="w-full"
					name="phone"
					v-validate="{ required: true, regex: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/ }"
				/>
				<span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first("phone") }}</span>

				<!-- DEPARTMENT -->
				<div class="mt-5">
					<label for class="vs-input--label">{{ $t("Department") }}:</label>
					<v-select
						class="select-tree"
						:placeholder="`${$t('Actions.Choose')} ${$t('Department').toLowerCase()}`"
						v-model="departmentId"
						:reduce="department => department.value"
						label="text"
						name="department"
						:options="departmentChoices"
					>
						<template v-slot:option="option">
							<div :class="`flex items-center pl-${option.depth > 1 ? option.depth * 2 : option.depth}`">
								<i class="mr-2 nucleo nucleo-shape-oval-3"></i>
								{{ option.text }}
							</div>
						</template>
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
				</div>

				<!-- TITLE -->
				<div class="mt-5">
					<label for class="vs-input--label">{{ $t("Title") }}:</label>
					<v-select :placeholder="`${$t('Actions.Choose')} ${$t('Title').toLowerCase()}`" v-model="titleId" :reduce="title => title.value" label="text" name="title" :options="titleChoices">
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
				</div>

				<div class="mt-5">
					<label for class="vs-input--label">{{ $t("ConcurrentTitles") }}:</label>
					<v-select
						multiple
						:placeholder="`${$t('Actions.Choose')} ${$t('ConcurrentTitles').toLowerCase()}`"
						v-model="titleIds"
						:reduce="title => title.id"
						:getOptionLabel="option => `${option.name} - ${option.department.name}`"
						name="titles"
						:options="titlesChoices"
						class="select-multiple w-full"
					>
						<template v-slot:option="option">
							<div>{{ option.name }} - {{ option.department.name }}</div>
						</template>
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
				</div>

				<div class="mt-5">
					<CbsTags v-model="tags" />
				</div>
				<!-- Allow Login -->
				<div v-if="mixinIsCanCreateBackendUser">
					<vs-checkbox class="my-4" v-model="isStudent">{{ $t("IsStudent") }}</vs-checkbox>
					<vs-checkbox v-if="dataId != null" :disabled="haveAccount && !user.can_update" class="my-4" v-model="allowLogin">{{ $t("AllowLogin") }}</vs-checkbox>
					<vs-checkbox v-if="dataId == null" class="my-4" v-model="allowLogin">{{ $t("AllowLogin") }}</vs-checkbox>
					<div v-if="allowLogin" class="w-full">
						<div class="vx-col w-full relative">
							<label for class="vs-input--label">
								{{ $t("Username") }}
								<span class="text-danger">*</span>:
							</label>
							<vs-input
								size="large"
								v-validate="'min:6|required'"
								:placeholder="`${$t('Actions.Input')} ${$t('Username').toLowerCase()}`"
								:data-vv-as="$t('Username')"
								name="_username"
								v-model="user.login"
								class="w-full"
								:disabled="dataId && haveAccount && !mixinIsCanUpdateBackendUser"
							/>
							<span class="text-danger text-sm" v-show="errors.has('_username')">{{ errors.first("_username") }}</span>
						</div>
						<div class="vx-col w-full mt-5" v-if="!dataId || (dataId && !haveAccount)">
							<label for class="vs-input--label">
								{{ $t("Password") }}
								<span class="text-danger">*</span>:
							</label>
							<vs-input
								:type="type['password']"
								size="large"
								v-validate="'min:6|max:50|required'"
								:data-vv-as="$t('Password')"
								:placeholder="`${$t('Actions.Input')} ${$t('Password').toLowerCase()}`"
								name="_password"
								v-model="user.password"
								class="w-full"
							/>
							<i
								@click="visiblePassword('password')"
								:class="['nucleo visible-password text-2xl', type['password'] === 'password' ? 'nucleo-cmviewvisible' : 'nucleo-cmviewdisable']"
							></i>
							<span class="text-danger text-sm" v-show="errors.has('_password')">{{ errors.first("_password") }}</span>
						</div>
					</div>
				</div>
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center flex-wrap items-center" slot="footer">
			<vs-button :type="dataId ? 'filled' : 'border'" :class="['w-full sm:w-1/3 sm:mr-6 font-bold', { 'mb-3 sm:mb-0': !dataId }]" @click.stop="submitData(!!dataId)">
				{{ dataId ? $t("Actions.Save") : $t("Actions.SaveAndRecreate") }}
			</vs-button>
			<vs-button v-show="!dataId" class="w-full sm:w-1/3 font-bold" @click.stop="submitData(true)">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import { backendUserPermissions, getUserPermissions } from "@/mixins/mixins.js";
import CbsTags from "@/components/cbs-tags/CbsTags";
import * as _ from "lodash";
export default {
	mixins: [getUserPermissions({ ...backendUserPermissions })],

	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	watch: {
		isSidebarActive(val) {
			console.log('isSidebarActive: ', val);
			if (!val) return;
			if (Object.entries(this.data).length === 0) {
				this.initValues();
			} else {
				let { id, name, code, department_id, title_id, email, dob, phone, user, tags, is_student, titles } = this.data;

				this.dataId = id;
				this.titleId = title_id;
				this.departmentId = department_id;
				this.initDepartmentId = this.departmentId;
				this.dataCode = code;
				this.dataName = name;
				this.dataEmail = email;
				this.dataPhone = phone;
				this.birthDate = dob || null;
				this.user = user;
				this.allowLogin = user ? true : false;
				this.haveAccount = user && user.login ? true : false;
				this.tags = tags;
				this.isStudent = is_student;
				this.titleIds = titles.map((title) => title.id);
			}

			this.isFormDirty = false;
			this.initFormData = {
				dataId: this.dataId,
				dataName: this.dataName,
				dataCode: this.dataCode,
				dataEmail: this.dataEmail,
				dataPhone: this.dataPhone,
				titleId: this.titleId,
				departmentId: this.departmentId,
				birthDate: this.birthDate,
				tags: this.tags,
				user: _.cloneDeep(this.user),
				allowLogin: this.allowLogin,
				isStudent: this.isStudent,
				titleIds: this.titleIds
			};
		},
		computedFormData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData) && newVal.dataId === this.initFormData.dataId;
			},
			deep: true
		},
		departmentId() {
			if (this.initDepartmentId !== this.departmentId) {
				this.titleId = null;
			}
		},
		allowLogin() {
			if (this.allowLogin && ((!this.dataId && this.dataEmail) || !this.haveAccount)) {
				this.user = {
					login: this.dataEmail,
					password: "cmacmacma",
					is_activated: true
				};
			}
		}
	},
	data() {
		return {
			dataId: null,
			dataName: "",
			dataCode: "",
			dataEmail: "",
			dataPhone: "",
			titleId: null,
			departmentId: null,
			birthDate: null,
			tags: [],
			initDepartmentId: null,
			listDepartment: [],
			listTitle: [],
			titleIds: [],

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			initFormData: {},
			isFormDirty: false,
			user: {
				login: "",
				password: "",
				is_activated: true
			},
			isStudent: false,
			allowLogin: false,
			type: {
				password: "password"
			},
			haveAccount: false
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.allowLogin = false;
					this.$emit("closeSidebar");
				}
			}
		},

		departmentChoices() {
			return (this.getFormattedFlattenTreeDepartments || []).map(department => ({
				value: department.id,
				text: department.name,
				depth: department.depth
			}));
		},
		...mapGetters({
			getFormattedFlattenTreeDepartments: "departmentManagement/getFormattedFlattenTreeDepartments"
		}),
		computedFormData() {
			return {
				dataId: this.dataId,
				dataName: this.dataName,
				dataCode: this.dataCode,
				dataEmail: this.dataEmail,
				dataPhone: this.dataPhone,
				titleId: this.titleId,
				departmentId: this.departmentId,
				birthDate: this.birthDate,
				tags: this.tags,
				user: this.user,
				allowLogin: this.allowLogin,
				isStudent: this.isStudent,
				titleIds: this.titleIds
			};
		},
		titleChoices() {
			let dataTitles = [];
			this.$store.state.titleManagement.titles.map(title => {
				if (title.department) {
					if (title.department.id == this.departmentId) {
						dataTitles.push({
							value: title.id,
							text: title.name
						});
					}
				}
			});
			return (dataTitles);
		},
		titlesChoices() {
			let dataTitles = [];
			this.$store.state.titleManagement.titles.map(title => {
				dataTitles.push(title);
			});
			return (dataTitles);
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.dataId = null;
			this.dataName = "";
			this.dataCode = "";
			this.dataPhone = "";
			this.dataEmail = "";
			this.departmentId = null;
			this.titleId = null;
			this.birthDate = null;
			this.tags = [];
			this.user = {
				login: "",
				password: "",
				is_activated: true
			};
			this.isStudent = false;
			this.titleIds = [];
			this.$validator.reset().then(() => {
				this.allowLogin = false;
			});
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			if (isCloseForm) {
				this.$emit("closeSidebar");
			}
			this.initValues();
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.dataId ? "UpdateEmployeeSuccessful" : "CreateEmployeeSuccessful"}`)
				}
			});
			this.$emit("refetchDataList");
		},
		async handleCreateOrUpdateEmployee(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				if (this.dataId) {
					await this.$store.dispatch("employeeManagement/updateEmployee", {
						...dataObj,
						id: this.dataId
					});
					if (!this.allowLogin) {
						await this.$store.dispatch("employeeManagement/blockAccount", { id: this.dataId, block: true });
					}
				} else {
					await this.$store.dispatch("employeeManagement/addEmployee", dataObj);
				}

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					if (this.user && this.user.__typename) {
						delete this.user.__typename;
						delete this.user.can_delete;
						delete this.user.can_update;
					}
					let tag_ids = this.tags;
					if (this.tags && this.tags[0] && this.tags[0].id) {
						tag_ids = _.map(this.tags, "id"); // [12, 14, 16, 18]
					}
					const dataObj = {
						name: this.dataName,
						code: this.dataCode || "",
						title_id: this.titleId || null,
						department_id: this.departmentId || null,
						email: this.dataEmail || "",
						phone: this.dataPhone || "",
						dob: this.birthDate || null,
						user: this.user && this.user.login && this.allowLogin ? this.user : null,
						tag_ids: tag_ids,
						is_student: this.isStudent || false,
						title_ids: this.titleIds || []
					};

					this.handleCreateOrUpdateEmployee(dataObj, isCloseForm);
				}
			});
		},
		async fetchFormOptions() {
			try {
				await Promise.all([this.$store.dispatch("departmentManagement/fetchDepartments", {}), this.$store.dispatch("titleManagement/fetchTitles", {})]);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		triggerClickDatetimePicker() {
			this.$refs.dateTimePickerRef.$children[0].pickerVisible = true;
		},
		visiblePassword(ref) {
			this.type[ref] = this.type[ref] === "password" ? "text" : "password";
		}
	},
	components: {
		vSelect,
		CbsTags
	},
	created() {
		this.fetchFormOptions();
	}
};
</script>
